const CANADIAN_POSTAL_CODE_REGEX = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/;

export function normalizeCanadianPostalCode(value) {
  if (!value) {
    return "";
  }
  return value.toUpperCase().replace(/[\s-]/g, "");
}

export function isValidCanadianPostalCode(value) {
  const normalized = normalizeCanadianPostalCode(value);
  if (!normalized) {
    return true;
  }
  return CANADIAN_POSTAL_CODE_REGEX.test(normalized);
}
